import { render } from "./ContactArea.vue?vue&type=template&id=5ae9b71b"
import script from "./ContactArea.vue?vue&type=script&lang=js"
export * from "./ContactArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__